import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Apply from "@/pages/Apply";

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/kurslar" element={<Courses />} />
          <Route path="/kurslar/:slug" element={<CourseDetail />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/galeri" element={<Gallery />} />
          <Route path="/sss" element={<FAQ />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/basvuru" element={<Apply />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
